<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/point_sub.jpg" />
      <h1 class="">マナビスポイント履歴</h1>
    </div>
    <div class="d-md-flex px-3 py-4 border-bottom">
      <div class="mr-3 mb-3">履歴日付指定</div>
      <div class="d-flex">
        <select v-model="searchYear1" class="w-auto px-3">
          <option v-for="year in yearOption" :key="year">
            {{ year }}
          </option></select
        >年
        <select v-model="searchMonth1" class="w-auto px-3">
          <option v-for="month in monthOption" :key="month">
            {{ month }}
          </option></select
        >月
        <select v-model="searchDay1" class="w-auto px-3">
          <option v-for="day in dayOption" :key="day">{{ day }}</option></select
        >日
      </div>
      <div class="mx-3">～</div>
      <select v-model="searchYear2" class="w-auto px-3">
        <option v-for="year in yearOption" :key="year">
          {{ year }}
        </option></select
      >年
      <select v-model="searchMonth2" class="w-auto px-3">
        <option v-for="month in monthOption" :key="month">
          {{ month }}
        </option></select
      >月
      <select v-model="searchDay2" class="w-auto px-3">
        <option v-for="day in dayOption" :key="day">{{ day }}</option></select
      >日
      <div class="d-flex"></div>
    </div>
    <div class="d-md-flex px-3 py-4 border-bottom">
      <div class="mr-5">
        <input
          class="mb-2 mr-3"
          type="radio"
          v-model="searchType"
          value="0"
          name="show"
          checked
        />全件表示
      </div>
      <div class="mr-5">
        <input
          class="mb-2 mr-3"
          type="radio"
          v-model="searchType"
          value="1"
          name="show"
        />付与分のみ表示
      </div>
      <div class="mr-5">
        <input
          class="mb-2 mr-3"
          type="radio"
          v-model="searchType"
          value="2"
          name="show"
        />使用分のみ表示
      </div>
      <div>
        <input
          class="mb-2 mr-3"
          type="radio"
          v-model="searchType"
          value="3"
          name="show"
        />有効期限切れのみ表示
      </div>
    </div>
    <div class="py-4 px-3 text-center border-bottom">
      <button v-on:click="search">検索</button>
    </div>
    <div class="only_pc">
      <div class="d-flex border-bottom py-3 px-3 point-list">
        <div>日付</div>
        <div>注文番号</div>
        <div>付与ポイント</div>
        <div>使用ポイント</div>
        <div>有効期限</div>
        <div>残ポイント</div>
      </div>
      <div>
        <ul v-for="History in displayHistory" :key="History['no']">
          <PointHistory :History="History" />
        </ul>
      </div>
    </div>
    
    <div class="sp_point_container only_sp">
      <div v-for="History in displayHistory" :key="History['no']">
        <PointHistorySp :History="History" />
      </div>
    </div>

    <!-- jPages navigation panel -->
    <div class="jPageholder my-5">
      <a v-on:click="prev" class="jp-previous jp-disabled">前頁</a>
      <a
        v-for="n of maxPage"
        v-on:click="setPage(n)"
        :key="n"
        :class="[currentPage == n ? 'jp-current' : '']"
        >{{ n }}</a
      >
      <a v-on:click="next" class="jp-next">次頁</a>
    </div>
  </section>
</template>

<script>
import Request from "@/modules/Request";
import PointHistory from "./components/PointHistory";
import PointHistorySp from "./components/PointHistorySp";
import Message from "@/modules/Message";
let request = new Request();

export default {
  components: {
    PointHistory,
    PointHistorySp,
  },
  data() {
    return {
      Histories: {},
      searchHistories: {},
      currentPage: 1,
      maxPage: 0,
      pageLines: 10,
      displayHistory: "",
      yearOption: [],
      monthOption: [],
      dayOption: [],
      searchType: "0",
      searchYear1: "",
      searchMonth1: "",
      searchDay1: "",
      searchYear2: "",
      searchMonth2: "",
      searchDay2: "",
    };
  },
  mounted() {
    this.getData();
    window.scroll(0, 0)
  },
  methods: {
    getData() {
      let requestParams = request.createParams(
        "webMdlResult",
        "getPointResult",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.Histories = data;
          let count = 0;
          this.Histories.forEach((e) => {
            e["no"] = count;
            count++;
          });
          this.maxPage = Math.ceil(this.Histories.length / this.pageLines);
          this.setDate();
          this.searchHistories = this.Histories;
          this.setPage(1);
        });
    },
    setDate() {
      let year1 = 2022;
      let year2 = 2031;
      this.yearOption.push('');
      for (let i = year1; i < year2; i++) {
        this.yearOption.push(i);
      }
      this.monthOption.push('');
      for (let i = 1; i < 13; i++) {
        if (i < 10) {
          this.monthOption.push("0" + i);
        } else {
          this.monthOption.push(i);
        }
      }
      this.dayOption.push('');
      for (let i = 1; i < 32; i++) {
        if (i < 10) {
          this.dayOption.push("0" + i);
        } else {
          this.dayOption.push(i);
        }
      }
    },
    isDate(str, delim) {
      var arr = str.split(delim);
      if (arr.length !== 3) return false;
      const date = new Date(arr[0], arr[1] - 1, arr[2]);
      if (
        arr[0] !== String(date.getFullYear()) ||
        arr[1] !== ("0" + (date.getMonth() + 1)).slice(-2) ||
        arr[2] !== ("0" + date.getDate()).slice(-2)
      ) {
        return false;
      } else {
        return true;
      }
    },
    checkDate() {
      let date1 =
        this.searchYear1 + "/" + this.searchMonth1 + "/" + this.searchDay1;
      let date2 =
        this.searchYear2 + "/" + this.searchMonth2 + "/" + this.searchDay2;
      let error = false;
      if (
        this.searchYear1 == "" &&
        this.searchMonth1 == "" &&
        this.searchDay1 == "" &&
        this.searchYear2 == "" &&
        this.searchMonth2 == "" &&
        this.searchDay2 == ""
      )
        error = true;
      if (
        this.searchYear1 != "" &&
        this.searchMonth1 != "" &&
        this.searchDay1 != "" &&
        !this.isDate(date1, "/")
      )
        error = true;
      if (
        this.searchYear2 != "" &&
        this.searchMonth2 != "" &&
        this.searchDay2 != "" &&
        !this.isDate(date2, "/")
      )
        error = true;
      let searchDate1 = new Date(
        this.searchYear1 +
          "/" +
          this.searchMonth1 +
          "/" +
          this.searchDay1 +
          " 00:00:00"
      );
      let searchDate2 = new Date(
        this.searchYear2 +
          "/" +
          this.searchMonth2 +
          "/" +
          this.searchDay2 +
          " 23:59:59"
      );
      if (searchDate1 > searchDate2) error = true;
      if (error) {
        Message.error().fire({
          title: "正しい日付を入力して下さい",
        });
        return false;
      }
      return true;
    },
    search() {
      if (!this.checkDate()) return false;
      let searchDate1 = new Date(
        this.searchYear1 +
          "/" +
          this.searchMonth1 +
          "/" +
          this.searchDay1 +
          " 00:00:00"
      );
      let searchDate2 = new Date(
        this.searchYear2 +
          "/" +
          this.searchMonth2 +
          "/" +
          this.searchDay2 +
          " 23:59:59"
      );
      console.log("this.serchType:" + this.searchType);

      switch (this.searchType) {
        case "0":
          //全件表示
          this.searchHistories = [];
          console.log('date1'+searchDate1)
          console.log('date2'+searchDate2)
          for (let i = 0; i < this.Histories.length; i++) {
            if (searchDate1 == "Invalid Date") {
              console.log('test1')
              if (new Date(this.Histories[i]["日付"]) <= searchDate2) {
                this.searchHistories.push(this.Histories[i]);
              }
            } else if (searchDate2 == "Invalid Date") {
              console.log('test2')
              if (new Date(this.Histories[i]["日付"]) >= searchDate1) {
                this.searchHistories.push(this.Histories[i]);
              }
            } else {
              console.log('test3')
              if (
                new Date(this.Histories[i]["日付"]) >= searchDate1 &&
                new Date(this.Histories[i]["日付"]) <= searchDate2
              ) {
                this.searchHistories.push(this.Histories[i]);
              }
            }
          }
          this.setPage(1);
          break;
        case "1":
          //付与分のみ表示
          this.searchHistories = [];
          console.log(this.Histories.length);
          for (let i = 0; i < this.Histories.length; i++) {
            if (searchDate1 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) <= searchDate2) {
                if (parseInt(this.Histories[i]["付与ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else if (searchDate2 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) >= searchDate1) {
                if (parseInt(this.Histories[i]["付与ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else {
              if (
                new Date(this.Histories[i]["日付"]) >= searchDate1 &&
                new Date(this.Histories[i]["日付"]) <= searchDate2
              ) {
                if (parseInt(this.Histories[i]["付与ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            }
          }
          this.setPage(1);
          break;
        case "2":
          //使用分のみ表示
          this.searchHistories = [];
          for (let i = 0; i < this.Histories.length; i++) {
            if (searchDate1 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) <= searchDate2) {
                if (parseInt(this.Histories[i]["使用ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else if (searchDate2 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) >= searchDate1) {
                if (parseInt(this.Histories[i]["使用ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else {
              if (
                new Date(this.Histories[i]["日付"]) >= searchDate1 &&
                new Date(this.Histories[i]["日付"]) <= searchDate2
              ) {
                if (parseInt(this.Histories[i]["使用ポイント"]) > 0) {
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            }
          }
          this.setPage(1);
          break;
        case "3":
          //有効期限切れのみ表示
          this.searchHistories = [];
          for (let i = 0; i < this.Histories.length; i++) {
            if (searchDate1 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) <= searchDate2) {
                if (
                  new Date(this.Histories[i]["有効期限年月日"]) < new Date()
                ) {
                  console.log("push");
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else if (searchDate2 == "Invalid Date") {
              if (new Date(this.Histories[i]["日付"]) >= searchDate1) {
                if (
                  new Date(this.Histories[i]["有効期限年月日"]) < new Date()
                ) {
                  console.log("push");
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            } else {
              if (
                new Date(this.Histories[i]["日付"]) >= searchDate1 &&
                new Date(this.Histories[i]["日付"]) <= searchDate2
              ) {
                if (
                  new Date(this.Histories[i]["有効期限年月日"]) < new Date()
                ) {
                  console.log("push");
                  this.searchHistories.push(this.Histories[i]);
                }
              }
            }
          }
          this.setPage(1);
          break;
      }
      this.maxPage = Math.ceil(this.searchHistories.length / this.pageLines);
    },
    setPage(page) {
      console.log(this.searchHistories);
      this.currentPage = page;
      let endCount = this.currentPage * this.pageLines;
      let startCount = endCount - this.pageLines;
      this.searchHistories.sort(function (a, b) {
        console.log(a["日付"])
        console.log(b["日付"])
        if (a["日付"] < b["日付"]) {
          console.log('1')
          return 1;
        } else {
          console.log('-1')
          return -1;
        }
      });
      this.displayHistory = this.searchHistories.slice(startCount, endCount);
      this.displayHistory.splice();
    },
    next() {
      if (this.currentPage == this.maxPage) return;
      this.setPage(this.currentPage + 1);
    },
    prev() {
      if (this.currentPage == 1) return;
      this.setPage(this.currentPage - 1);
    },
  },
};
</script>

<style scoped>
.point-list div {
  width: 17%;
}
.sp_point_container {
  padding: 20px;
}
.sp_point_container > div {
    padding: 10px;
    border: 1px solid #dee2e6;
    margin-top: 20px;
}
</style>